













































import {Vue, Component} from 'vue-property-decorator';
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import dataProxy from "@/services/data-proxy.service";
import * as signalR from "@aspnet/signalr";
import {HubConnection} from "@aspnet/signalr";
import {TuraDto} from "@/services/BackendProxies";
import {formatDateTime} from "@/utils/formatters";

@Component
export default class PregledTura extends mixins(ComponentBaseMixin) {
  zvtFile = null;
  isBusy = false;
  isProcessing = false;
  columns = [];
  datum = new Date();
  data = [];
  tableOptions = {
    search: true,
    showExport: true,
    exportTypes: ['excel']
  }
  connection: HubConnection;

  async created() {
    this.columns = [
      {field: '', formatter: this.statusFormatter, width: '32px'},
      {field: 'nazivPrevoznika', title: this.$i18n.t('nazivPrevoznika'), sortable: true },
      {field: 'ruta', title: this.$i18n.t("ruta"), sortable: true},
      {field: 'pocetakUtovara', title: this.$i18n.t("pocetakUtovara"), sortable: true, width: '80px'},
      {field: 'krajUtovara', title: this.$i18n.t("krajUtovara"), sortable: true, width: '80px'},
      {field: 'trajanjeUtovara', title: this.$i18n.t("trajanjeUtovara"), sortable: true, width: '80px', formatter: (v, item) => item.dugacakUtovar ? `<span class="text-danger">${v}</span>` : v},
      {field: 'planiraniBrojOtpremnica', title: this.$i18n.t("planiraniBrojOtpremnica"), align: 'right', sortable: true, width: '80px'},
      {field: 'brojOtpremnica', title: this.$i18n.t("brojOtpremnica"), align: 'right', sortable: true, width: '80px', formatter: (v, item) => item.razlicitBrojOtpremnica ? `<span class="text-danger">${v}</span>` : v},
      {field: 'brojPovratnica', title: this.$i18n.t("brojPovratnica"), align: 'right', sortable: true, width: '80px'},
      {field: 'brojPredjenihKilometara', title: this.$i18n.t("predjenoKilometara"), align: 'right', sortable: true, width: '80px'},
      {field: 'datumZavrsetka', title: this.$i18n.t("datumZavrsetka"), formatter: formatDateTime, sortable: true, width: '80px'},
      {field: 'napomena', title: this.$i18n.t("napomena")},
    ];

    this.connection = new signalR.HubConnectionBuilder().withUrl("/hubs/3pl").build();
    this.connection.on("Refresh", this.notificationReceived);
    await this.connection.start();
  }

  destroy() {
    this.connection.stop();
  }

  async notificationReceived(datum) {
    try {
      this.data = await this.loadData(() => dataProxy.vratiPlanTura(this.datum))();
    } catch (e) {
      this.showError(<string>this.$i18n.t('nesupesnoCuvanjePodataka'));
    }
  }

  async uvezi() {
    this.isBusy = true;
    try {
      await this.saveData(() => dataProxy.uveziPlanRuta(this.zvtFile))();
    } catch (e) {
      this.showError(<string>this.$i18n.t('nesupesnoCuvanjePodataka'));
    } finally {
      this.isBusy = false;
    }
  }

  async prikazi() {
    this.isProcessing = true;
    try {
      this.data = await this.loadData(() => dataProxy.vratiPlanTura(this.datum))();
    } catch (e) {
      this.showError(<string>this.$i18n.t('nesupesnoCuvanjePodataka'));
    } finally {
       this.isProcessing = false;
    }
  }

  statusFormatter(column, tura: TuraDto) {
    if (tura.zavrsena) return '<div class="traffic-lights-green"></div>'
    return tura.prihvacena ? '<div class="traffic-lights-yellow"></div>' : '<div class="traffic-lights-red"></div>'
  }
}
